import styled from '@emotion/styled'
import media from '../../../styles/media'

const S = {}

S.HeroCarousel = styled.section`
  height: 33rem;
  background: rgba(0, 0, 0, 0.7);

  ${media.sm`
    height: 43.75rem;
  `};

  ${media.md`
    height: 37.75rem;
  `};
`

export default S